import { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, TextField,
  MenuItem, Divider, Typography, CircularProgress, Box,
} from "@mui/material";
import Swal from "sweetalert2";
import { getPerfil, salvarPerfil, getEstados, getCidades } from "../../services/candidatoService";

const SEXOS = [{ v: "M", l: "Masculino" }, { v: "F", l: "Feminino" }, { v: "O", l: "Outro" }];

export default function MeusDadosDialog({ open, onClose }) {
  const [f, setF] = useState(null);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const set = (campo, v) => setF((p) => ({ ...p, [campo]: v }));

  useEffect(() => {
    if (!open) return;
    setF(null);
    (async () => {
      const [perfil, est] = await Promise.all([getPerfil(), getEstados()]);
      setEstados(est.data);
      const d = perfil.data;
      setF({
        ...d,
        DataNascimento: d.DataNascimento ? String(d.DataNascimento).slice(0, 10) : "",
        Sexo: SEXOS.some((s) => s.v === d.Sexo) ? d.Sexo : "",
      });
      if (d.CodEstado) { try { setCidades((await getCidades(d.CodEstado)).data); } catch (_) {} }
    })();
  }, [open]);

  useEffect(() => {
    if (!f?.CodEstado) return;
    getCidades(f.CodEstado).then((r) => setCidades(r.data)).catch(() => {});
  }, [f?.CodEstado]);

  const salvar = async () => {
    setSalvando(true);
    try {
      await salvarPerfil({ ...f, CodEstado: f.CodEstado || null, CodCidade: f.CodCidade || null });
      await Swal.fire("Pronto", "Dados atualizados com sucesso.", "success");
      onClose();
    } catch (e) {
      Swal.fire("Erro", e?.response?.data?.mensagem || e?.response?.data || e.message, "error");
    } finally { setSalvando(false); }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Meus dados cadastrais</DialogTitle>
      <DialogContent dividers>
        {!f ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}><CircularProgress /></Box>
        ) : (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}><Typography variant="subtitle2" color="primary">Dados pessoais</Typography><Divider /></Grid>
            <Grid size={{ xs: 12, sm: 4 }}><TextField fullWidth label="CPF" value={f.Cpf || ""} disabled /></Grid>
            <Grid size={{ xs: 12, sm: 8 }}><TextField fullWidth label="Nome completo" value={f.Nome || ""} onChange={(e) => set("Nome", e.target.value)} /></Grid>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Nome social" value={f.NomeSocial || ""} onChange={(e) => set("NomeSocial", e.target.value)} /></Grid>
            <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth type="date" label="Nascimento" InputLabelProps={{ shrink: true }} value={f.DataNascimento || ""} onChange={(e) => set("DataNascimento", e.target.value)} /></Grid>
            <Grid size={{ xs: 6, sm: 3 }}>
              <TextField select fullWidth label="Sexo" value={f.Sexo || ""} onChange={(e) => set("Sexo", e.target.value)}>
                {SEXOS.map((s) => <MenuItem key={s.v} value={s.v}>{s.l}</MenuItem>)}
              </TextField>
            </Grid>

            <Grid size={{ xs: 12 }}><Typography variant="subtitle2" color="primary" sx={{ mt: 1 }}>Contato</Typography><Divider /></Grid>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="E-mail" value={f.Email || ""} onChange={(e) => set("Email", e.target.value)} /></Grid>
            <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="Telefone" value={f.Telefone || ""} onChange={(e) => set("Telefone", e.target.value)} /></Grid>
            <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="Telefone 2" value={f.Telefone2 || ""} onChange={(e) => set("Telefone2", e.target.value)} /></Grid>

            <Grid size={{ xs: 12 }}><Typography variant="subtitle2" color="primary" sx={{ mt: 1 }}>Endereço</Typography><Divider /></Grid>
            <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="CEP" value={f.Cep || ""} onChange={(e) => set("Cep", e.target.value)} /></Grid>
            <Grid size={{ xs: 6, sm: 3 }}>
              <TextField select fullWidth label="Estado" value={f.CodEstado || ""} onChange={(e) => { set("CodEstado", e.target.value); set("CodCidade", ""); }}>
                {estados.map((es) => <MenuItem key={es.CodUf} value={es.CodUf}>{es.Sigla} — {es.Nome}</MenuItem>)}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField select fullWidth label="Cidade" value={f.CodCidade || ""} disabled={!f.CodEstado} onChange={(e) => set("CodCidade", e.target.value)}>
                {cidades.map((c) => <MenuItem key={c.CodMunicipio} value={c.CodMunicipio}>{c.Municipio}</MenuItem>)}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 5 }}><TextField fullWidth label="Endereço" value={f.Endereco || ""} onChange={(e) => set("Endereco", e.target.value)} /></Grid>
            <Grid size={{ xs: 4, sm: 2 }}><TextField fullWidth label="Número" value={f.Numero || ""} onChange={(e) => set("Numero", e.target.value)} /></Grid>
            <Grid size={{ xs: 8, sm: 5 }}><TextField fullWidth label="Bairro" value={f.Bairro || ""} onChange={(e) => set("Bairro", e.target.value)} /></Grid>
            <Grid size={{ xs: 12 }}><TextField fullWidth label="Complemento" value={f.Complemento || ""} onChange={(e) => set("Complemento", e.target.value)} /></Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
        <Button variant="contained" onClick={salvar} disabled={!f || salvando}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
}
